import { STATUS_FILTERS, type StatusFilter } from '@/lib/projectStatus';

interface ProjectToolbarProps {
  search: string;
  onSearchChange: (value: string) => void;
  status: StatusFilter;
  onStatusChange: (value: StatusFilter) => void;
}

export default function ProjectToolbar({
  search,
  onSearchChange,
  status,
  onStatusChange,
}: ProjectToolbarProps) {
  return (
    <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
      <div className="relative w-full lg:max-w-sm">
        <span className="pointer-events-none absolute left-3 top-1/2 flex h-4 w-4 -translate-y-1/2 items-center justify-center text-foreground-400">
          <i className="ri-search-line text-base"></i>
        </span>
        <input
          type="text"
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder="Buscar por proyecto o cliente..."
          className="h-11 w-full rounded-md border border-background-300 bg-background-50 pl-10 pr-9 text-sm text-foreground-900 placeholder:text-foreground-400 transition-colors focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-200"
        />
        {search && (
          <button
            type="button"
            onClick={() => onSearchChange('')}
            aria-label="Limpiar búsqueda"
            className="absolute right-2 top-1/2 flex h-7 w-7 -translate-y-1/2 cursor-pointer items-center justify-center rounded-md text-foreground-400 transition-colors hover:bg-background-100 hover:text-foreground-700"
          >
            <i className="ri-close-line text-base"></i>
          </button>
        )}
      </div>

      <div className="flex flex-wrap items-center gap-1 rounded-full border border-background-200 bg-background-50 px-1 py-1">
        {STATUS_FILTERS.map((filter) => {
          const active = status === filter.value;
          return (
            <button
              key={filter.value}
              type="button"
              onClick={() => onStatusChange(filter.value)}
              className={[
                'cursor-pointer whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-medium transition-colors duration-200',
                active
                  ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
                  : 'text-foreground-600 hover:bg-background-100 hover:text-foreground-900',
              ].join(' ')}
            >
              {filter.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}